<template>
<div class="record_box">
  <section class="box_top">
    <img src="../../assets/images/icon_park.png" />
    <p>月租缴费</p>
    <strong>{{dataMess.payAmount|priceFormat}}</strong>
  </section>
  <ul class="record_main border">
    <li class="li_item">
      <p class="item_left">充值起始时间</p>
      <p class="item_right">{{dataMess.startDay}}</p>
    </li>
    <li class="li_item">
      <p class="item_left">充值到期时间</p>
      <p class="item_right">{{dataMess.endDay}}</p>
    </li>
    <li class="li_item border-bottom">
      <p class="item_left">月租费</p>
      <p class="item_right">¥ {{dataMess.feeStandard|priceFormat}}</p>
    </li>
    <li class="li_item pay_time">
      <p class="item_left">缴费时间</p>
      <p class="item_right">{{dataMess.paySuccessAt}}</p>
    </li>
  </ul>
</div>
</template>

<script>
import {mapState} from 'vuex';
import storage from '../../utils/storage';
import wx from 'weixin-js-sdk'
//import wx from 'jweixin-1.6.0'
export default {
  name: 'paymentRecordDetail',
  props: {},
  components: {
  },
  filters: {
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  data() {
    return {
      dataMess:[]
    }
  },
  created() {
    let dataMess = JSON.parse(storage.get('recordItem') || '');
    this.dataMess = dataMess;
    console.log(dataMess)
  },
  beforeDestroy(){
    storage.remove('recordItem')
  }
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
.record_box{
  background:#eee;
  .box_top{
    padding:40px 0 60px;
    .flex(column);
    align-items: center;
    justify-content: center;
    img{
      width:96px;
      height:96px;
      margin-bottom:20px;
    }
    p{
      font-size:28px;
      color:rgba(51,51,51,1);
      line-height:40px;
      margin-bottom:20px;
    }
    strong{
      font-size:48px;
      font-weight:bold;
      color:rgba(51,51,51,1);
      line-height:58px;
    }
  }
  .record_main{
    background:rgba(252,252,252,1);
    border-radius:8px;
    overflow: hidden;
    margin:0 20px 20px;
    padding:20px 28px 0;
    .li_item{
      .flex();
      justify-content: space-between;
      padding:20px 0;
      .item_left{
        font-size:28px;
        color:rgba(102,102,102,1);
        line-height:40px;
      }
      .item_right{
        font-size:28px;
        color:rgba(51,51,51,1);
        line-height:40px;
      }
    }
    .pay_time{
      padding:28px 0;
    }
  }
}
</style>
